import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";

const JavaScriptLesson5 = () => {
  const [language, changeLanguage] = useState("bash");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `node -v`
  );

  const code2 = (
  'text',
  `node index`
  );

  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
      <h3><strong>Run JavaScript From Terminal</strong></h3>
      <p>You can also run JavaScript from the terminal by installing <var><b>Node.js</b></var> from their site <var><b>https://nodejs.org/en/download</b>/</var></p>
      <p><b>Node.js</b> is an open source cross-platform runtime environment for server-side JavaScript. Node.js is required to run JavaScript without a browser. It uses Google V8 JavaScript engine to execute the code.</p>
      <p>After installation, check if node is installed by running the command below: </p>

      {/*<pre><code>node -v //prints v16.8.0</code></pre> */}
      <CopyBlock
      language={language}
      text={code}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
      />
      <p className="mt-3 mb-3">Assuming the name of your file is <b class="text-primary">index.js</b>, To run your project, open it from the terminal and run the command: </p>
      {/*<pre class="mb-4"><code>node index //prints Hello World!</code></pre> */}
      <CopyBlock
      language={language}
      text={code2}
      showLineNumbers={lineNumbers}
      theme={dracula}
      wrapLines={true}
      codeBlock
        />

      <h3 className="mt-3">Summary</h3>
      <ul className="list-group">
        <li className="list-group-item">JavaScript can be run and debugged in the browser.</li>
        <li className="list-group-item">JavaScript can also be run without the browser using <var>Node.js</var></li>
      </ul>

      <div style={{ height: 450 }} />

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson5
